module.exports = __webpack_public_path__ + "img/no-foto.c2169916.png";